import { IRootState } from 'affiny-core/modules/state';

export const selectIsMainLayoutVisible = (state: IRootState): boolean =>
  state.visibilityUi.desktop.mainLayout;
